import Avatar from 'components/ui/Avatar';

import { useHistory } from 'react-router-dom';

function ShortBotCard(bot) {
  const { enabled } = bot;
  const history = useHistory();

  const handleClick = () => {
    history.push(`marketplace/${bot.id}`);
  };

  const transparentBackground = enabled ? '' : 'card-bg-white-transparent';

  return (
    <div className={`card border-0 shadow-sm clickable ${transparentBackground}`}>
      <div className="card-body">
        <div onClick={handleClick} className="row">
          <div className="col-md-3">
            <Avatar name={bot.name} src={bot.profile_image} size={44} className="shadow rounded-circle" />
          </div>
          <div className="col-md-9 text-truncate">
            <div>
              <b>{bot.name}</b>
            </div>
            <div className="text-truncate">{bot.description}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ShortBotCard;
